import { render, staticRenderFns } from "./ModuleProgress.vue?vue&type=template&id=1a1bb366&scoped=true&"
import script from "./ModuleProgress.vue?vue&type=script&lang=js&"
export * from "./ModuleProgress.vue?vue&type=script&lang=js&"
import style0 from "./ModuleProgress.vue?vue&type=style&index=0&id=1a1bb366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1bb366",
  null
  
)

export default component.exports